  <ion-list class="ion-no-padding">
    <ion-item lines="none" (click)="redirectToProfilePage()">
        <ion-label>Perfil</ion-label>
    </ion-item>
    <ion-item lines="none" (click)="logout()">
        <ion-icon name="log-out" slot="end"></ion-icon>
        <ion-label>Cerrar sesión</ion-label>
    </ion-item> 
  </ion-list>